export default function namespace(name, block) {
  let target = window;
  for (const item of name.split('.'))
    target = target[item] || (target[item] = {});
  if (block) block(target);
}
